import { peakWindowSegment } from '@/lib/programs'

/** The day as a 24-hour bar with the no-charging window marked; `dark` sits on a dark-blue background. */
export function PeakWindowBar({ start, end, tone = 'light' }: { start: string; end: string; tone?: 'light' | 'dark' }) {
  const { leftPct, widthPct } = peakWindowSegment(start, end)
  const ticks = [
    { label: '00:00', pct: 0, peak: false },
    { label: '08:00', pct: (8 / 24) * 100, peak: false },
    { label: start, pct: leftPct, peak: true },
    { label: end, pct: leftPct + widthPct, peak: true },
  ]
  return (
    <figure className="w-full" aria-label={`Niet thuis laden tussen ${start} en ${end}`}>
      <div className={`relative h-11 overflow-hidden rounded-xl ${tone === 'dark' ? 'bg-white/15' : 'bg-light-green'}`}>
        <div
          className="absolute inset-y-0 flex items-center justify-center bg-warning text-13 font-bold text-white"
          style={{ left: `${leftPct}%`, width: `${widthPct}%` }}
        >
          Niet laden
        </div>
      </div>
      <div className="relative mt-2 h-4 text-13 font-semibold" aria-hidden="true">
        {ticks.map((t) => (
          <span
            key={t.label}
            className={`absolute ${t.peak ? 'text-warning' : tone === 'dark' ? 'text-white/60' : 'text-dark-blue/50'}`}
            style={{ left: `${t.pct}%`, transform: t.pct === 0 ? undefined : 'translateX(-50%)' }}
          >
            {t.label}
          </span>
        ))}
      </div>
    </figure>
  )
}
